import { render, staticRenderFns } from "./proxyUserList.vue?vue&type=template&id=c633991c&scoped=true"
import script from "./proxyUserList.vue?vue&type=script&lang=js"
export * from "./proxyUserList.vue?vue&type=script&lang=js"
import style0 from "./proxyUserList.vue?vue&type=style&index=0&id=c633991c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c633991c",
  null
  
)

export default component.exports